import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const DotsThreeIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="DotsThreeIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/dots-three">
            <path
                d="M13.5032 4.9967C13.5032 5.82709 12.83 6.50024 11.9996 6.50024C11.1693 6.50024 10.4961 5.82709 10.4961 4.9967C10.4961 4.16632 11.1693 3.49316 11.9996 3.49316C12.83 3.49316 13.5032 4.16632 13.5032 4.9967Z"
                fill="currentColor"
            >
            </path>
            <path
                d="M13.5032 12.0005C13.5032 12.8309 12.83 13.504 11.9996 13.504C11.1693 13.504 10.4961 12.8309 10.4961 12.0005C10.4961 11.1701 11.1693 10.4969 11.9996 10.4969C12.83 10.4969 13.5032 11.1701 13.5032 12.0005Z"
                fill="currentColor"
            >
            </path>
            <path
                d="M13.5032 19.0043C13.5032 19.8347 12.83 20.5078 11.9996 20.5078C11.1693 20.5078 10.4961 19.8347 10.4961 19.0043C10.4961 18.1739 11.1693 17.5007 11.9996 17.5007C12.83 17.5007 13.5032 18.1739 13.5032 19.0043Z"
                fill="currentColor"
            >
            </path>
        </g>
    </SvgIcon>
)
